import { ArrowUpRight } from "lucide-react";
import { MARQUEE_ITEMS } from "../data/siteData";

const Row = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={i} className="flex items-center gap-6 px-8">
        <span className="font-serif text-3xl uppercase tracking-tight text-[#14110D] sm:text-4xl">{item.platform}</span>
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#C8402A]">{item.month}</span>
        <span className="font-serif text-3xl italic text-[#8C867E] sm:text-4xl">Кадър</span>
        <span className="h-2 w-2 rounded-full bg-[#C8402A]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const doubled = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section className="overflow-hidden border-y border-[#14110D]/10 py-14" data-testid="social-marquee">
      <div className="marquee-track flex w-max">
        <Row items={doubled} />
        <Row items={doubled} />
      </div>
      <div className="mt-12 flex flex-col items-center gap-5 px-5">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8C867E]">Последвай Alex</p>
        <div className="flex flex-wrap justify-center gap-3">
          {[
            { name: "Instagram", url: "https://www.instagram.com/aleksandercholakov/" },
            { name: "YouTube", url: "https://www.youtube.com/@AleksandarCholakov-z4h" },
          ].map((s) => (
            <a
              key={s.name}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-link-${s.name.toLowerCase()}`}
              className="group flex items-center gap-2 rounded-full border border-[#14110D]/20 px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.22em] text-[#14110D] transition-colors duration-300 hover:bg-[#14110D] hover:text-[#F4F1EA]"
            >
              {s.name}
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
